module.exports = __webpack_public_path__ + "media/images/vp/sample.map-82f2fd828eb8d1c6bad1b203d852eeb4.png";